export default "__VITE_ASSET__BIxT_4Px__"